import React from "react";
import { toast } from "sonner";
import { RotateCcw } from "lucide-react";
import api, { formatError } from "../lib/api";
import { useApi } from "../hooks/useApi";
import { CollapsibleList } from "./CollapsibleList";
import { Button } from "./ui/button";

const when = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { timeZone: "America/New_York", dateStyle: "medium", timeStyle: "short" }) : "—");

export function DeletedRegistrations({ refreshKey, onRestored }) {
  const { data, reload } = useApi("/admin/registrations/deleted", [refreshKey]);
  const rows = data || [];
  const restore = async (r) => {
    try {
      await api.post(`/admin/registrations/${r.id}/restore`);
      toast.success(`Application ${r.tracking_id} restored to the queue`); reload(); onRestored?.();
    } catch (e) { toast.error(formatError(e.response?.data?.detail)); }
  };
  return (
    <div className="mb-8" data-testid="deleted-registrations">
      <CollapsibleList id="deleted-registrations" title="Deleted applications" rows={rows} defaultOpen={false} searchable
        matcher={(r, q) => `${r.first_name} ${r.last_name} ${r.email} ${r.tracking_id} ${r.deleted_reason} ${r.deleted_by}`.toLowerCase().includes(q)}
        placeholder="Search deleted applications…" empty="No applications have been deleted."
        render={(r) => (
          <div key={r.id} className="rounded-lg border border-gold/20 bg-parchment-card p-3 text-sm" data-testid={`deleted-reg-${r.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-2">
              <p className="font-semibold">{r.first_name} {r.last_name} <span className="font-mono-accent text-xs text-gold">{r.tracking_id}</span>
                <span className="ml-2 text-xs text-muted-foreground">{r.email}</span></p>
              <div className="flex items-center gap-3">
                <p className="text-xs text-muted-foreground">Deleted by <span className="font-semibold text-crimson">{r.deleted_by}</span> · {when(r.deleted_at)}</p>
                <Button size="sm" variant="outline" className="gap-1 border-palm/40 text-palm" onClick={() => restore(r)} data-testid={`deleted-reg-restore-${r.id}`}><RotateCcw size={14} /> Restore</Button>
              </div>
            </div>
            <p className="mt-1 text-muted-foreground"><span className="eyebrow text-gold">Reason</span> {r.deleted_reason}</p>
          </div>
        )} />
    </div>
  );
}
